import { useTranslation } from 'react-i18next';
import { allSettled } from 'effector';
import { useUnit } from 'effector-react';
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import { $config, $error, clearError, createFilterToolbarScope } from '../../model';

export const ErrorMessage = () => {
  const { t } = useTranslation();
  const [error, config] = useUnit([$error, $config]);

  const clearErrorFunc = async () => {
    const scope = createFilterToolbarScope(config!.id);
    await allSettled(clearError, { scope, params: null });
  };

  return (
    <Dialog onClose={clearErrorFunc} open={!!error}>
      <DialogTitle>{t('Error')}</DialogTitle>

      <DialogContent>
        <DialogContentText>{error?.message ?? t('DataLoadingError')}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={clearErrorFunc}>
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
